module.exports = __webpack_public_path__ + "img/icon401.4ebf0668.png";